export const SET_ACTIVE_BUSINESS_ID = "setActiveBusinessId";
export const SET_ACTIVE_SERVICE = "setActiveService";
export const SET_ACTIVE_SERVICE_ID = "setActiveServiceId";
export const SET_ASSOCIATED_BUSINESSES = "setAssociatedBusinessesqq";
export const SET_ERROR = "setError";
export const SET_OPEN_RIGHT_DETAILS_PANEL = "setOpenRightDetailsPanel";
export const SET_PROFILE_FORM_PANEL='setProfileFormPanel';
export const SET_LOADING = "setLoading";
export const SET_RIDE_INFO = "setRideInfo";
export const SET_SERVICES = "setServices";
export const SET_TAB_STATE = "setTabState";
export const SET_TENANT_SETTINGS = "setTenantSettings";
export const SET_TOAST = 'setToast'
